import { CheckIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Center,
  Flex,
  Heading,
  Image,
  Text,
  VStack,
  useClipboard,
  useDisclosure,
  useToast,
  chakra,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  useMediaQuery,
  HStack,
  useTab,
} from '@chakra-ui/react';
import { TbHandClick } from 'react-icons/tb';

import { AccountContext } from 'components/AccountContext';
import NoUserHeader from 'components/AreaLivre/NoUserHeader';
import UserHeaderLivre from 'components/AreaLivre/UserHeaderLivre';
import ChildHeader from 'components/Dashboard/Main/ChildHeader';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ReactComponent as Heart } from '../../../images/heart.svg';
import { ReactComponent as FamiliaPlus } from '../../../images/familia-plus.svg';
import { ReactComponent as Familia } from '../../../images/plano-familia.svg';
import { ReactComponent as Individual } from '../../../images/individual.svg';
import { ReactComponent as PlanoRecomendado } from '../../../images/plano-recomendado.svg';
import { loadPlans } from 'api/plans';

function ClubeVantagem() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [valor, setValor] = useState([]);
  const { setPage, setUser, user } = useContext(AccountContext);
  const { url_externa, url_interna, cupom, link_vantagem, descricao, valor_cupom, percentual, nome_site, botao, titulo, apenas_online } = state;
  const { id_contrato, descricao_plano, titular } = user;
  const toast = useToast();
  const [value, setValue] = useState(cupom);
  const { hasCopied, onCopy } = useClipboard(value);
  setPage('Clube de Vantagens');
  const [tipo, setTipo] = useState('');
  const [medico, setMedico] = useState(false);
  const disclosure = useDisclosure();
  let usuarioAssinante = id_contrato && user.descricao_plano ? true : false;
  if (user.titular === false) usuarioAssinante = true;

  return (
    <>
      {user.loggedIn ? <ChildHeader /> : <NoUserHeader />}
      <Flex direction={{ base: 'column', md: 'row' }} gap={6} maxW="700px" w="100%" mx="auto" px={4} py={4} align="stretch">
        <Box
          flex={1}
          width="100%"
          minWidth={0}
          minHeight="220px"
          borderRadius="1em"
          overflow="hidden"
          display="flex"
          alignItems="center"
          justifyContent="center"
          boxShadow="none"
        >
          <img
            src={url_interna}
            alt="Imagem da vantagem"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              display: 'block',
            }}
          />
        </Box>
        <Box
          flex={1}
          width="100%"
          minWidth={0}
          boxSizing="border-box"
          bg="radial-gradient(circle at center, #CFEDEA 0%, #E6F6F4 55%, #F3FBFA 100%)"
          border="1px solid #86C8C5"
          px={{ base: 4, md: 8 }}
          py={{ base: 4, md: 8 }}
          borderRadius="1em"
          display="flex"
          flexDirection="column"
          justifyContent="center"
        >
          <Heading textAlign="center" fontSize="20px" color="#5AB2AE" mb={4} fontWeight="bold">
            {titulo}
          </Heading>

          <Text textAlign="center" fontSize="14px" color="#5AB2AE" whiteSpace="pre-wrap" m={2}>
            {descricao}
          </Text>

          {!usuarioAssinante && (
            <Text textAlign="center" fontSize="14px" color="#616161" mt={4} whiteSpace="pre-wrap">
              Para usufruir dos descontos dos parceiros DeoVita você precisa ser um assinante!
            </Text>
          )}
          {cupom !== null && cupom.length > 0 && (
            <Center mt={2}>
              <Box bg="#5AB2AE" color="white" p={2} borderRadius="full" fontWeight="bold" fontSize="15px" letterSpacing="1px" h="2.5em">
                {cupom}
              </Box>
            </Center>
          )}

          {link_vantagem && (
            <Center w="100%" mt={2}>
              <Button
                bg="#1F655D"
                color="white"
                w="100%"
                fontWeight="bold"
                borderRadius="full"
                mt="1.5em"
                h="2.5em"
                leftIcon={<TbHandClick />}
                onClick={() => window.open(link_vantagem, '_blank')}
                fontSize={'15px'}
              >
                {botao || nome_site}
              </Button>
            </Center>
          )}

          {apenas_online && (
            <Text textAlign="center" fontSize="14px" color="#616161" mt={4} bg="#F9F2E2" p={2} borderRadius="1em" border="1px solid #EAC886">
              Este cupom só é válido para pedidos online.
            </Text>
          )}
        </Box>
      </Flex>
    </>
  );
}

export default ClubeVantagem;
